'use client';

import { useAuth } from '@clerk/clerk-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '../api/client';

export function useUpdatePaymentMethod() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (paymentMethodId: string) => {
      const token = await getToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const { data, error } = await apiClient.PUT(
        '/api/v1/billing/payment-method',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: {
            paymentMethodId: paymentMethodId,
          },
        }
      );

      if (error || !data) {
        throw new Error('Failed to update payment method');
      }

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['billing-summary'] });
      queryClient.invalidateQueries({ queryKey: ['payment-method'] });
    },
  });
}
